// extracted by mini-css-extract-plugin
export default {"header":"Header_header__d+igc","projectName":"Header_projectName__fbX+D","logoutButton":"Header_logoutButton__GpDDV"};